import {ColumnSpec} from './ColumnSpec';

export class TableSpec
{
    constructor(
            public readonly columns:ColumnSpec[], 
            public readonly reordering:string[], 
            public readonly deleteColumns:string[], 
            public readonly deleteAllExcept:string[]
        )
    {}
}
